import React, { useMemo, useState, useEffect } from 'react';
import { MantineReactTable } from 'mantine-react-table';
import { useTheme } from '../../../ThemeContext'; // Adjust the path as necessary
import { MantineProvider, Loader, Text } from '@mantine/core';
import { formatDate } from '../../../api/services';
import AddSafety from '../Forms/Saftey';
import { getAllSafetyInspection, deleteSafetyInspection } from '../../../api/api';
import { EyeIcon, TrashIcon, PencilIcon } from '@heroicons/react/24/outline';
import ConfirmationModal from '../../ConfirmationModal';

export const Safety = () => {
  const { theme } = useTheme(); // Get the theme from context
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false); // Loader state
  const [isOpen, setIsOpen] = useState(false); // Manage modal visibility
  const [edit, setEdit] = useState(false); // Manage edit mode
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const handleOpen = () => setIsOpen(true); // Open modal
  const handleClose = () => setIsOpen(false); // Close modal
  const [safetyId, setSafetyId] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const res = await getAllSafetyInspection();
        setData(res.data.safety); // Set fetched data
        // console.log(res.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false); // Set loading to false after fetching
    };
    fetchData();
  }, [update]);

  const columns = useMemo(() => [
    {
      accessorKey: 'projectId.project_name',
      header: 'Area',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'siteEngineerName',
      header: 'Site  Engineer',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'area',
      header: 'Area',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'description',
      header: 'Description',
    },
    {
      accessorKey: 'deadLine',
      header: 'Deadline',
      Cell: ({ cell }) => formatDate(cell.getValue()) || 'N/A',
    },
    {
      accessorKey: 'result',
      header: 'Result',
    },
    {
      accessorKey: 'comments',
      header: 'Comments',
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      Cell: ({ row }) => (
        <div className="flex space-x-2">
          <PencilIcon
            className="w-5 h-5 text-blue-600 hover:text-blue-800 cursor-pointer"
            onClick={() => handleEditRow(row)}
          />

          <TrashIcon
            className="w-5 h-5 text-red-600 hover:text-red-800 cursor-pointer"
            onClick={() => openDeleteConfirmation(row)}
          />
        </div>
      ),
    },
  ], []);
  const handleUpdate = () => {
    setUpdate(!update);
  }
  const openDeleteConfirmation = (row) => {
    setEditData(row.original);
    setEdit(true)
    setConfirmModalOpen(true);
  };

  const handleDeleteRow = async () => {
    // console.log(editData._id);
    if (editData) {
      try {
        await deleteSafetyInspection(editData._id);
        setConfirmModalOpen(false);
        handleUpdate();
        setEdit(false)
      } catch (error) {
        console.error('Error deleting project:', error);
      }
    }
  };

  const handleEditRow = (row) => {
    setEdit(true)
    setEditData(row.original);
    setIsOpen(true)
  };
  return (
    <MantineProvider
      theme={{
        colorScheme: theme,
        primaryColor: 'blue',
        primaryShade: 5,
      }}
    >
      <div className="flex justify-between p-2 bg-gray-700 items-center text-md">
        <p className="text-lg">Safety</p>
        {/* Button to trigger modal */}
        <button
          className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto"
          onClick={handleOpen}
        >
          Safety Inspection
        </button>
      </div>
      {/* Show loader while data is being fetched */}
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Loader color="blue" size="xl" />
        </div>
      ) : (
        <>


          {/* Safety Table */}
          <div className="overflow-x-auto max-h-screen">
            <MantineReactTable
              columns={columns}
              data={data}
              enableColumnActions
              enableColumnFilters
              enablePagination
              enableSorting
              enableRowNumbers
              enableGlobalFilter
              mantineTableProps={{
                highlightOnHover: true,
                withBorder: true,
                sx: {
                  'thead > tr': {
                    backgroundColor: theme === 'dark' ? '#1a202c' : '#f7fafc',
                  },
                  'thead > tr > th': {
                    backgroundColor: theme === 'dark' ? '#2d3748' : '#edf2f7',
                    color: theme === 'dark' ? '#e2e8f0' : '#2d3748',
                  },
                  'tbody > tr': {
                    '&:hover': {
                      backgroundColor: theme === 'dark' ? '#2d3748' : '#f1f5f9',
                    },
                  },
                  'tbody > tr > td': {
                    backgroundColor: theme === 'dark' ? '#2d3748' : '#ffffff',
                    color: theme === 'dark' ? '#ffff' : '#333333',
                  },
                },
              }}
            />
          </div>

          {/* Modal for AddSafety form */}
        </>
      )}
      {isOpen && <AddSafety onClose={handleClose} isOpen={isOpen} editData={editData} handleUpdate={handleUpdate} edit={edit} setEdit={setEdit} />}
      <ConfirmationModal
        isOpen={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleDeleteRow}
        title="Confirm Deletion"
        message="Are you sure you want to delete this?"
      />
    </MantineProvider>
  );
};

export default Safety;
